<authority-labs-base-dialog
  [dialogRef]="dialogRef"
  title="ייבוא מטיוטה"
  size="large"
>
  <div content>
    <!-- Stats bar -->
    <div class="stats-bar" *ngIf="phase === 'ready' || phase === 'done'">
      <span class="stat">
        <strong>{{ results.length }}</strong> שדות
      </span>
      <span class="stat success" *ngIf="editedCount > 0">
        <strong>{{ editedCount }}</strong> הוזנו
      </span>
    </div>

    <!-- Preparing phase -->
    <div class="loading-container" *ngIf="phase === 'preparing'">
      <nz-spin nzSimple nzSize="large"></nz-spin>
      <p>טוען שדות...</p>
    </div>

    <!-- Error -->
    <div class="error-container" *ngIf="error && phase !== 'preparing'">
      <i nz-icon nzType="close-circle" nzTheme="outline" class="error-icon"></i>
      <p>{{ error }}</p>
      <button nz-button nzType="primary" (click)="prepare()">נסה שוב</button>
    </div>

    <!-- Results table -->
    <div
      class="results-container"
      *ngIf="
        (phase === 'ready' || phase === 'done') && !error && results.length > 0
      "
    >
      <div *ngFor="let section of sections" class="section-group">
        <h3
          class="section-title"
          *ngIf="getResultsBySection(section).length > 0"
        >
          {{ section }}
        </h3>

        <div
          *ngFor="let result of getResultsBySection(section)"
          class="result-row"
        >
          <!-- Checkbox -->
          <label
            nz-checkbox
            [(ngModel)]="result.selected"
            class="result-checkbox"
            [nzDisabled]="!result.rawText"
          ></label>

          <!-- Field title -->
          <div class="field-title">{{ result.fieldTitle }}</div>

          <!-- Ink image -->
          <div class="ink-preview" *ngIf="result.inkImageBase64">
            <img
              [src]="'data:image/png;base64,' + result.inkImageBase64"
              alt="כתב יד"
              class="ink-image"
            />
          </div>

          <!-- Display recognized text (not editing) -->
          <div
            class="recognized-text"
            *ngIf="!result.editing && result.rawText"
          >
            <span class="text-value">{{ result.rawText }}</span>
          </div>

          <!-- Empty state (not editing, no text) -->
          <div
            class="recognized-text"
            *ngIf="!result.editing && !result.rawText"
          >
            <span class="text-value pending-text">לא הוזן</span>
          </div>

          <!-- Edit mode -->
          <div class="edit-field" *ngIf="result.editing">
            <input
              #editInput
              nz-input
              [value]="result.rawText"
              (keyup.enter)="saveEdit(result, editInput.value)"
              (keyup.escape)="cancelEdit(result)"
              class="edit-input"
            />
            <button
              nz-button
              nzType="text"
              nzShape="circle"
              (click)="saveEdit(result, editInput.value)"
              nz-tooltip
              nzTooltipTitle="שמור"
            >
              <i nz-icon nzType="check" nzTheme="outline"></i>
            </button>
            <button
              nz-button
              nzType="text"
              nzShape="circle"
              (click)="cancelEdit(result)"
              nz-tooltip
              nzTooltipTitle="בטל"
            >
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </button>
          </div>

          <!-- Edit button -->
          <button
            nz-button
            nzType="text"
            nzShape="circle"
            *ngIf="!result.editing"
            (click)="startEdit(result)"
            nz-tooltip
            nzTooltipTitle="ערוך"
          >
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </button>

          <!-- Clear button (only when field has value) -->
          <button
            nz-button
            nzType="text"
            nzShape="circle"
            *ngIf="!result.editing && result.rawText"
            (click)="clearField(result)"
            nz-tooltip
            nzTooltipTitle="נקה"
          >
            <i nz-icon nzType="close-circle" nzTheme="outline"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div
      class="empty-container"
      *ngIf="phase !== 'preparing' && !error && results.length === 0"
    >
      <i nz-icon nzType="highlight" nzTheme="outline" class="empty-icon"></i>
      <p>לא נמצאו שדות עם כתב יד לזיהוי</p>
    </div>
  </div>

  <!-- Footer actions -->
  <nz-space actions *ngIf="phase !== 'preparing'">
    <button *nzSpaceItem nz-button nzType="primary" (click)="applyDraft()">
      ייבא טיוטה
      <span *ngIf="editedCount > 0"> ({{ editedCount }})</span>
    </button>
    <ng-template nzSpaceItem></ng-template>
  </nz-space>
</authority-labs-base-dialog>
